export class RouteApiLiveServer {
  static postGoLive = `/streaming/post-go-live?`;
  static postEndStreaming = `/streaming/post-end-streaming?`;
  static postUser = `/streaming/post-user?`;
}

